export default [
    '/Account/Reactivate',
    '/Account/Reactivate/Contact',
];